<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/5D4L6075.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Features & Amenities / Leading Edge Technology" h1="Streaming Capabilities" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <Accordian v-for="(accordian, key) in accordians" :key="key" :preview="accordian.preview" :icon="accordian.icon" :info="accordian.info"/>
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
//TODO
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Accordian from "@/patterns/Accordian.vue";
export default {
  name: "StreamingCapabilities",
  components: { PageLeft, TitleContent, Accordian },
  data: () => ({
    scrollContent: false,    
    accordians:[
      {
        "preview" : "Full HDR (High Dynamic Range)<br/>capabilities",
        "icon" : "features_and_amenities/icon-white_HDR.svg",
        "info" : [
          "5 Sony HDR cameras with Canon box lenses",
          "2 Sony HDR wired handheld cameras",
          "2 Sony HDR wireless cameras"
        ]
      },
      {
        "preview" : "Broadcast quality production control room with streaming capabilities",
        "icon" : "features_and_amenities/icon-white_broadcast.svg",
        "info" : [
          "18 channels of replay records",
          "7 channels of CG",
          "4 channels of video playback"
        ]
      }
    ]
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>